import PrdDragEvent from '@prd/shared-ui/src/models/PrdDragEvent';

export default class DragState {
    public event: PrdDragEvent = new PrdDragEvent();
}
